import { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/GiantLog-logo.png';
import { getUiInterface } from '../../locales/translationUtils';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  useEffect(() => {
    // Redireciona para a página /404 assim que o componente for renderizado
    navigate('/404', { replace: true });
  }, [navigate]);

  return (
    <Container fluid className="d-flex flex-column align-items-center justify-content-center vh-100 text-center bg-light">
      <Row className="mb-4">
        <Col>
          <img 
            src={logo} 
            alt="Logo" 
            style={{ maxWidth: '200px', height: 'auto' }} 
            className="img-fluid"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <h1 className="display-4 fw-bold text-primary">404</h1>
          <p className="fs-5 text-secondary">{getUiInterface('pageNotFound')}</p>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <Button variant="primary" onClick={handleGoHome}>
            {getUiInterface('goBackToHome')}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;